import { useIsTablet } from "@/config/hooks";
import { useNavigate } from "react-router-dom";
import { useUpload } from "../upload/useUpload";

export function useUploadNewMobile() {
  // -----------------------------------------------------------------------------
  // GENERAL
  // -----------------------------------------------------------------------------
  const navigate = useNavigate();
  const isTablet = useIsTablet();

  function onBack() {
    navigate(-1);
  }

  return {
    onBack,
    isTablet,
    ...useUpload({ onCloseDialog: () => navigate("/upload") }),
  };
}
